import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import getRelativeUrl from 'utils/getRelativeUrl'
import { Link } from 'react-router-dom'
import easing from 'ui/styles/easing'

const Wrapper = styled.div`
  width: 100%;
  background-color: ${props => props.theme.colors.theme.light};
  background-image: ${props => props.hasImage ? '' : 'url(' + props.theme.colors.theme.brush3 + ')'};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: ${props => props.hasImage ? '100px' : '20px'};
  position: relative;
`

const Title = styled.h1`
  font-size: 70px;
  line-height: 70px;
  color: ${props => props.theme.colors.grey.lightest};
  text-align: center;

  ${media.xs`
    font-size: 45px;
    line-height: 45px;
    padding: 0 20px;
  `}
`

const TextContainer = styled(Container)`
  padding: ${props => props.hasImage ? '175px 0 30px' : '175px 0 150px'};

  ${media.xs`
    padding: ${props => props.hasImage ? '120px 0 0' : '120px 0 60px'};
  `}
`

const Text = styled.p`
  color: ${props => props.theme.colors.grey.lightest};
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  margin-bottom: 0;

  ${media.xs`
    padding: 0 20px;
  `}
`

const Image = styled.div`
  width: calc(100% - 50px);
  margin-left: 50px;
  transform: translateY(${props => props.theme.navHeight}px);
  background: url(${props => props.image}) center / cover;
  padding-bottom: 40%;

  ${media.xs`
    padding-bottom: 100%;
    width: 100%;
    margin-left: 0;
    transform: translateY(60px);
  `}
`

const Brush = styled.div`
  position: absolute;
  bottom: -15%;
  width: 70%;
  z-index: 2;
  right: 50px;
  height: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: ${props => props.hasImage ? '' : 'url(' + props.theme.colors.theme.brush2 + ')'};
  padding-bottom: 14%;

  ${media.xs`
    display: none;
  `}
`

const Breadcrumbs = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colors.grey.darker};
  display: flex;
  margin-bottom: 80px;

  div {
    display: flex;
  }

  a {
    color: inherit;
    transition: 0.3s color ${easing.easeOutCubic};

    &:hover {
      color: ${props => props.theme.colors.theme.base};
    }
  }
`

export default class PageHeader extends Component {
  render() {
    const {
      title,
      text,
      image,
      pageTitle,
      ancestors,
    } = this.props

    return(
      <div>
        <Wrapper hasImage={image ? true : false}>
         
          {(title || text) &&
            <TextContainer
              fluid
              hasImage={image ? true : false}
            >
              <Row>
                <Col
                  sm={8}
                  smOffset={2}
                  lg={6}
                  lgOffset={3}
                >
                  {title &&
                    <Title>{title}</Title>
                  }
                  {text &&
                    <Text>{text}</Text>
                  }
                </Col>
              </Row>
            </TextContainer>
          }
        
          {image &&
            <Image image={image.sourceUrl} />
          }
          
          {image &&
            <Brush />
          }
        
        </Wrapper>

        <Container fluid>
          <Row>
            <Col>
              <Breadcrumbs>
                <Link to="/">Forside</Link>
                
                {ancestors && [...ancestors].reverse().map(parent => {
                  return(
                    <div>
                      <span>&ensp;/&ensp;</span>
                      <Link to={getRelativeUrl(parent.uri)}>{parent.title}</Link>
                    </div>
                  )
                })}
                
                <span>&ensp;/&ensp;{pageTitle}</span>
              </Breadcrumbs>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/PageHeader/index.js